/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerBedRoom } from './ScreenerBedRoom';
import {
    ScreenerBedRoomFromJSON,
    ScreenerBedRoomFromJSONTyped,
    ScreenerBedRoomToJSON,
    ScreenerBedRoomToJSONTyped,
} from './ScreenerBedRoom';

/**
 * 
 * @export
 * @interface FindAllBedRooms200Response
 */
export interface FindAllBedRooms200Response {
    /**
     * 
     */
    data?: Array<ScreenerBedRoom>;
}

/**
 * Check if a given object implements the FindAllBedRooms200Response interface.
 */
export function instanceOfFindAllBedRooms200Response(value: object): value is FindAllBedRooms200Response {
    return true;
}

export function FindAllBedRooms200ResponseFromJSON(json: any): FindAllBedRooms200Response {
    return FindAllBedRooms200ResponseFromJSONTyped(json, false);
}

export function FindAllBedRooms200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllBedRooms200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ScreenerBedRoomFromJSON)),
    };
}

export function FindAllBedRooms200ResponseToJSON(json: any): FindAllBedRooms200Response {
    return FindAllBedRooms200ResponseToJSONTyped(json, false);
}

export function FindAllBedRooms200ResponseToJSONTyped(value?: FindAllBedRooms200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ScreenerBedRoomToJSON)),
    };
}

